import { iam } from '@myap/ui-library/esm/profile'
import axios, { getServerErrorMessage } from '../utils/axios'
import { isEmpty } from '../utils/common'
import * as c from '../constants/TeacherConstants'

const { getJWTToken, getAuthSession } = iam()

export const fetchTeachers = (orgId, educationPeriodCd, testCd) => async dispatch => {
  const requestInfo = testCd
    ? { type: c.FETCH_TEACHERS_FULFILLED }
    : { type: c.FETCH_ORG_TEACHERS_FULFILLED }
  try {
    dispatch({ type: c.FETCH_TEACHERS_PENDING })
    const headers = {
      'X-CB-Catapult-Authentication-Token': getAuthSession().sessionId,
      'X-CB-Catapult-Authorization-Token': getJWTToken(),
    }
    const { data } = await axios.get(
      `${Config.API_GATE_URL}/course-auth/organizations/${orgId}/professionals`,
      { params: { epc: educationPeriodCd, ...(!isEmpty(testCd) ? { testCd } : {}) }, headers }
    )
    dispatch({ type: requestInfo.type, payload: { orgId, data: data?.professionals ?? [] } })
  } catch (err) {
    dispatch({ type: c.FETCH_TEACHERS_REJECTED, payload: getServerErrorMessage(err) })
  }
}
